"use client";

import { Icon } from "@/components/ui/icon";
import { cn } from "@/lib/utils";

export type SyncDirection =
  | "bidirectional"
  | "pull_only"
  | "push_only"
  | "unknown";

export function SyncDirectionIcon({
  direction,
  className,
  size = 14,
}: {
  direction: SyncDirection | null | undefined;
  className?: string;
  size?: number;
}) {
  if (direction === "bidirectional") {
    return (
      <Icon
        name="IconArrowsRepeatRightLeft"
        size={size}
        className={cn("text-muted-foreground shrink-0", className)}
      />
    );
  }
  if (direction === "pull_only") {
    return (
      <Icon
        name="IconArrowDown"
        size={size}
        className={cn("text-muted-foreground shrink-0", className)}
      />
    );
  }
  if (direction === "push_only") {
    return (
      <Icon
        name="IconArrowUp"
        size={size}
        className={cn("text-muted-foreground shrink-0", className)}
      />
    );
  }
  return null;
}
